module.exports = __webpack_public_path__ + "img/technoworld.b8a58c2d.png";